
export const pdfNotAvaialbeMunicipilities = ["Herstappe"]
export const dataNotAvailableMunicipilities = ["Herstappe"]

export function createDownloadPdfURL(municipalityName = null){
    if([null, undefined, "", ...pdfNotAvaialbeMunicipilities].includes(municipalityName)) return null

    return `https://vvsg-ikrb.s3.fr-par.scw.cloud/ikrb/${municipalityName}.pdf`
}
